// frontend/src/lib/publishRules.js
import { validatePublish } from "@/lib/catalogRules";
import { validateStartHereConfig } from "@/lib/startHereRules";
import { storesById } from "@/lib/siteConfigStore";

// The single publish gate: every rule that can block a publish is composed
// here, in one pure function, so the wiring itself is testable. AdminPage
// must call this (and only this) before publishing — do not inline extra
// checks in the component, add them here where the test suite pins them.
export function collectPublishErrors(config, orgConfig) {
  return [
    ...validatePublish(config.products, storesById(orgConfig), config.meta?.allowedKinds),
    // Publish-time validation runs even when the wizard is disabled — a
    // disabled-but-broken Start Here config must not publish silently.
    ...validateStartHereConfig(config.startHere, config.products, { includeDisabled: true }),
  ];
}
